import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  useEffect(() => {
    document.title = `Our story — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="about-page" id="main-content">
      <section className="about-hero" aria-labelledby="about-title">
        <p className="about-eyebrow">Our story</p>
        <h1 id="about-title">Small paper moments. Very big feelings.</h1>
        <p className="about-hero__intro">
          {siteConfig.description} We make keepsakes that turn an ordinary
          hello into something worth holding onto.
        </p>
        <div className="about-hero__doodle" aria-hidden="true">
          <span>fold</span>
          <i />
          <span>delight</span>
        </div>
      </section>

      <figure className="about-studio-image">
        <img
          src="/img/studio-story.jpg"
          alt={`${siteConfig.brandName} cards, paper samples and tools arranged in the studio`}
          loading="eager"
        />
        <figcaption>Designed slowly, opened joyfully.</figcaption>
      </figure>

      <section className="about-story" aria-labelledby="story-title">
        <div className="about-story__heading">
          <p className="about-eyebrow">How it started</p>
          <h2 id="story-title">A love note to meaningful mail</h2>
        </div>
        <div className="about-story__copy">
          <p>
            {siteConfig.brandName} began with a simple idea: the cards we give
            should feel every bit as special as the people receiving them. We
            pair playful paper engineering with warm, modern illustration to
            make every opening feel like a tiny celebration.
          </p>
          <p>
            Each piece starts with a sketch, then moves through rounds of
            folding, testing and refining. The result is tactile, surprising
            and easy to send—thoughtful design without the fuss.
          </p>
          <blockquote>
            “The best gifts are the ones that make someone feel completely
            seen.”
          </blockquote>
        </div>
      </section>

      <section className="about-values" aria-labelledby="values-title">
        <div className="about-values__intro">
          <p className="about-eyebrow">What matters here</p>
          <h2 id="values-title">Made with care, from first fold to forever</h2>
        </div>
        <div className="about-values__grid">
          <article className="about-value about-value--pink">
            <span aria-hidden="true">01</span>
            <h3>Delight in the details</h3>
            <p>
              Clever folds, satisfying movement and unexpected little moments
              make our paper goods feel alive.
            </p>
          </article>
          <article className="about-value about-value--mint">
            <span aria-hidden="true">02</span>
            <h3>Thoughtfully made</h3>
            <p>
              We choose sturdy papers, purposeful packaging and production
              partners who care about craft as much as we do.
            </p>
          </article>
          <article className="about-value about-value--gold">
            <span aria-hidden="true">03</span>
            <h3>Connection over perfection</h3>
            <p>
              A handwritten note does not need to be polished. It only needs
              to be honest, personal and sent with love.
            </p>
          </article>
        </div>
      </section>

      <section className="about-cta" aria-labelledby="about-cta-title">
        <p className="about-eyebrow">Send a little magic</p>
        <h2 id="about-cta-title">Find the card that says it just right.</h2>
        <div className="about-cta__actions">
          <Link className="about-button about-button--primary" to="/shop">
            Shop the collection
          </Link>
          <Link className="about-button about-button--secondary" to="/contact">
            Say hello
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
